import { getFile } from '../services/storeServices';

export const osDetector = () => {
  if (navigator.userAgent.match(/Android/i)) return 'android';
  if (
    navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
  ) return 'ios';

  return 'web';
}

export const downloadFile = async (reference) => {
  if (!reference) return
  const os = osDetector();

  const url = await getFile(reference).then(url => url);
  const link = document.createElement('a');

  if (os === 'ios') link.href = `itms-services://?action=download-manifest&amp;url=${url}`;
  else link.href = url;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}